import { render, staticRenderFns } from "./ConfigureDocumentField.vue?vue&type=template&id=cc72bba0&scoped=true"
import script from "./ConfigureDocumentField.vue?vue&type=script&lang=js"
export * from "./ConfigureDocumentField.vue?vue&type=script&lang=js"
import style0 from "./ConfigureDocumentField.vue?vue&type=style&index=0&id=cc72bba0&prod&scoped=true&lang=css"
import style1 from "./ConfigureDocumentField.vue?vue&type=style&index=1&id=cc72bba0&prod&scoped=true&lang=css"
import style2 from "./ConfigureDocumentField.vue?vue&type=style&index=2&id=cc72bba0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc72bba0",
  null
  
)

export default component.exports